

export class FormErrors {

  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.fields = this.container.querySelectorAll('.fields .field');
    this.container.addEventListener('submit', this, true);
    this.container.addEventListener('blur', this, true);
    this.container.addEventListener('invalid', this, true);
  }

  clear(e)
  {
    this.fields.forEach((f) => {
      f.classList.remove('error');
    });

    const errs = this.container.querySelector('ul.errors');
    if (errs) {
      errs.remove();
    }
  }

  invalid(e)
  {
    const parent = e.target.closest('.field');
    if (parent) { parent.classList.add('error'); }
  }

  blur(e)
  {
    const parent = e.target.closest('.field');
    if (parent && e.target.validity && e.target.validity.valid) {
      parent.classList.remove('error');
    }

    const err = this.container.querySelectorAll('ul.errors li[data-field="' + e.target.getAttribute('name') + '"]');
    if (err.length > 0) {
      err.forEach((e) => e.remove());
    }
  }

  handleEvent(e) {
    switch (e.type) {
      case 'submit':
        this.clear(e);
        break;
      case 'invalid':
        this.invalid(e);
        break;
      case 'blur':
        this.blur(e);
        break;
    }
  }
}
